<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.02 11.02">
    <defs>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Group_24891" data-name="Group 24891">
          <rect
            id="Rectangle_1269"
            data-name="Rectangle 1269"
            class="cls-1"
            x="-1.25"
            y="4.47"
            width="13.51"
            height="2.07"
            transform="translate(-2.28 5.51) rotate(-45)"
          />
          <rect
            id="Rectangle_1270"
            data-name="Rectangle 1270"
            class="cls-1"
            x="4.47"
            y="-1.25"
            width="2.07"
            height="13.51"
            transform="translate(-2.28 5.51) rotate(-45)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
